import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../utils/Api";
import Select from 'react-select';
import StaticFunctions from "../utils/StaticFunctions";


class OperatorSelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        onOperatorSelected: PropTypes.func.isRequired,
    };

    static defaultProps = {
        name: 'operator-select',
        currentOperator: null,
        addAllOption: false,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        const currentCompany = (this.props.baseData.companies) ? this.props.baseData.companies.currentCompany : null;

        this.state = {
            currentCompany: currentCompany,
            currentOperator: (this.props.currentOperator) ? this.props.currentOperator : null,
            currentCompanyOperators: [],
        };

        this.translate = this.props.baseData.translate;

        this.requestCompanyOperators = this.requestCompanyOperators.bind(this);
        this.selectOperator = this.selectOperator.bind(this);

    }

    componentDidMount() {

        this.requestCompanyOperators();

    }

    componentDidUpdate(prevProps) {

        const nextCompany = this.props.baseData.companies ? this.props.baseData.companies.currentCompany : null;
        const prevCompany = prevProps.baseData.companies ? prevProps.baseData.companies.currentCompany : null;

        if (JSON.stringify(nextCompany) !== JSON.stringify(prevCompany)) {
            this.setState({
                currentCompany: nextCompany
            }, () => {
                this.requestCompanyOperators();
            });
        }

    }

    requestCompanyOperators() {

        if (!this.state.currentCompany) return null;

        const params = {
            action: 'companyOperators',
            companyId: this.state.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanyOperators: res,
                });
            }
        }.bind(this);

        this.api.request('GetOperator', params, callback, null);

    }

    selectOperator(option) {

        if (option) {
            const id = String(option.value);

            this.setState({
                currentOperator: option
            });

            if (this.props.onOperatorSelected) this.props.onOperatorSelected(option)
        }

    }

    getOptions() {

        const operators = this.state.currentCompanyOperators ? this.state.currentCompanyOperators : [];
        const sortedOperators = StaticFunctions.getSortedData(operators, 'operator_name', 'string');
        const opts = [];

        if (this.props.addAllOption)  {
            opts.push({
                value: 'all',
                label: this.translate('all')
            })
        }

        return opts.concat(sortedOperators.map(
            (operator, index) => {
                let value = String(operator.id_operator);
                let label = (operator.operator_name) ? operator.operator_name : value;

                return {
                    index: index,
                    value: value,
                    label: label,
                };
            }
        ));

    }

    render() {
        const currentOperatorId = (this.state.currentOperator) ? String(this.state.currentOperator.value) : (this.props.addAllOption ? 'all' : null);
        const opts = this.getOptions();
        const selectedOption = opts.find(o => o.value === currentOperatorId) || null;

        return (
            <Select
                name={this.props.name}
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={opts}
                onChange={this.selectOperator}
                value={selectedOption}
                placeholder={this.translate('select') + '...'}
                clearable={false}
                noResultsText={this.translate('noResultsFound')}
            />
        )
    }

}

export default OperatorSelector;